import { useState } from 'react';
import type { BlockedDate } from '../../../../mocks/appointments';

interface Props {
  blockedDates: BlockedDate[];
  addBlockedDate: (
    date: string,
    reason?: string
  ) => Promise<BlockedDate | null>;
  removeBlockedDate: (id: string) => Promise<boolean>;
}

export default function BlockedDatesManager({
  blockedDates,
  addBlockedDate,
  removeBlockedDate,
}: Props) {
  const [date, setDate] = useState('');
  const [reason, setReason] = useState('');

  const handleAdd = async () => {
    if (!date) return;
    await addBlockedDate(date, reason || undefined);
    setDate('');
    setReason('');
  };

  return (
    <div className="space-y-6">
      <h2 className="font-serif text-brand-black text-2xl font-medium">
        Fechas bloqueadas
      </h2>
      <div className="bg-white border border-brand-gray-200 rounded-2xl p-6 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="font-sans text-brand-gray-600 text-xs uppercase tracking-wider font-medium">
              Fecha
            </label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="mt-1 w-full border border-brand-gray-200 rounded-lg px-3 py-2 font-sans text-sm"
            />
          </div>
          <div>
            <label className="font-sans text-brand-gray-600 text-xs uppercase tracking-wider font-medium">
              Motivo (opcional)
            </label>
            <input
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Vacaciones, evento..."
              className="mt-1 w-full border border-brand-gray-200 rounded-lg px-3 py-2 font-sans text-sm"
            />
          </div>
        </div>
        <button
          onClick={handleAdd}
          className="bg-brand-black text-white font-sans text-sm px-5 py-2.5 rounded-lg hover:bg-brand-gray-600 transition-colors whitespace-nowrap"
        >
          + Bloquear fecha
        </button>
      </div>

      <div className="bg-white border border-brand-gray-200 rounded-2xl overflow-hidden">
        <table className="w-full">
          <thead className="bg-brand-gray-50">
            <tr>
              <th className="text-left font-sans text-brand-gray-600 text-xs uppercase tracking-wider font-medium px-5 py-3">
                Fecha
              </th>
              <th className="text-left font-sans text-brand-gray-600 text-xs uppercase tracking-wider font-medium px-5 py-3">
                Motivo
              </th>
              <th className="text-right font-sans text-brand-gray-600 text-xs uppercase tracking-wider font-medium px-5 py-3">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-gray-200">
            {blockedDates.map((b) => (
              <tr key={b.id}>
                <td className="px-5 py-3 font-sans text-brand-black text-sm">
                  {b.date}
                </td>
                <td className="px-5 py-3 font-sans text-brand-gray-500 text-sm">
                  {b.reason || '—'}
                </td>
                <td className="px-5 py-3 text-right">
                  <button
                    onClick={() => removeBlockedDate(b.id)}
                    className="w-8 h-8 rounded-lg bg-brand-gray-100 flex items-center justify-center text-brand-gray-600 hover:bg-red-600 hover:text-white transition-colors"
                  >
                    <i className="ri-delete-bin-line" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {blockedDates.length === 0 && (
          <div className="p-8 text-center font-sans text-brand-gray-400 text-sm">
            No hay fechas bloqueadas
          </div>
        )}
      </div>
    </div>
  );
}